// Logo oficial global de la plataforma GLG GYM CONTROL (LOGO_OFICIAL_SISTEMA).
// Fuente única: /glg-logo-mark.png (proporciones originales preservadas, fondo transparente).
export const BrandLogo = ({ className = "", withWordmark = false, size = "h-9" }) => (
  <div className={`flex items-center gap-2.5 ${className}`}>
    <img
      src="/glg-logo-mark.png"
      alt="GLG GYM CONTROL"
      className={`${size} w-auto object-contain select-none shrink-0`}
      draggable="false"
      data-testid="brand-logo"
    />
    {withWordmark && (
      <div className="leading-none">
        <p className="font-display text-2xl tracking-wide">GLG GYM</p>
        <p className="overline text-[0.6rem] text-[#00f0ff]">CONTROL</p>
      </div>
    )}
  </div>
);

export default BrandLogo;
